import React from 'react';
import { toast } from 'react-toastify';
import { CloseIcon } from '../../../../../../components/Icons';
import { DARWIN_NAVY } from '../../../../../../constants';

interface ToastProps {
  onRefresh?: () => void;
}

export const UploadSuccess = ({ onRefresh }: ToastProps) => (
  <div className="toast__content">
    <h3 className="toast__title">Asset uploaded.</h3>
    <h4 className="toast__subtitle">
      <span
        style={{
          color: '#e1e3ff',
          cursor: 'pointer',
        }}
        onClick={onRefresh}
      >
        Refresh
      </span>{' '}
      to see results.
    </h4>
  </div>
);

export const UploadError = () => (
  <div className="toast__content">
    <h3 className="toast__title">Error uploading asset.</h3>
    <h4 className="toast__subtitle">Please try again.</h4>
  </div>
);

export const UploadLoading = () => (
  <div className="toast__content">
    <h3 className="toast__title">Uploading asset...</h3>
  </div>
);

const toastConfig = {
  position: 'top-right' as const,
  autoClose: false,
  hideProgressBar: false,
  closeOnClick: false,
  draggable: true,
  progress: undefined,
  closeButton: <CloseIcon className="toast__close" />,
  style: {
    background: DARWIN_NAVY,
    padding: 0,
  },
};

export const notifyUploadSuccess = (onRefresh?: () => void) =>
  toast(<UploadSuccess onRefresh={onRefresh} />, {
    ...toastConfig,
    toastId: 'success-toast-upload',
  });

export const notifyUploadError = () =>
  toast(<UploadError />, {
    ...toastConfig,
    toastId: 'error-toast-upload',
  });

export const notifyUploadLoading = () =>
  toast(<UploadLoading />, {
    ...toastConfig,
    toastId: 'loading-toast-upload',
  }); 